<button
    class="animation focus:outline-none bg-gray-100 shadow-md rounded-full  flex justify-center items-center w-40-px h-40-px hover:translate-y-1 transform hover:shadow-lg" style="border: #a6ce39 1px solid;"
    >
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#a6ce39" class="bi bi-arrow-up-short" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5z"/>
    </svg>
</button>